module.exports = __webpack_public_path__ + "static/media/language.1c3fe9ed.svg";